import { lazy } from "react";
import Loadable from "components/Loadable.tsx";
import Reports from "./components";

const IssueReports = Loadable(
  lazy(() => import("features/reports/components/IssueReports"))
);

const routes = {
  path: "reports",
  children: [{ path: "", element: <Reports /> }],
};

export default routes;
